import { createSlice } from "@reduxjs/toolkit";
import { getCommon, getLanguages, getLocation, getStreakTiming } from './thunk';
export const initialState = {
  common: {},
  location: {},
  languages: [],
  timing: [],
  error: {}
};

const Common = createSlice({
  name: 'Common',
  initialState,
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(getCommon.fulfilled, (state, action) => {
      state.common = action.payload;
    });

    builder.addCase(getCommon.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(getLanguages.fulfilled, (state, action) => {
      state.languages = action.payload;
    });

    builder.addCase(getLanguages.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(getLocation.fulfilled, (state, action) => {
      state.location = action.payload;
    });

    builder.addCase(getLocation.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(getStreakTiming.fulfilled, (state, action) => {
      state.timing = action.payload;
    });

    builder.addCase(getStreakTiming.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });
  }
});

export default Common.reducer;